<template>
  <div id="app">
    <NavBar></NavBar>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
import NavBar from './components/NavBar';
import Footer from './components/Footer';

export default {
  name: 'app',
  components: {
    NavBar,
    Footer
  },
};
</script>

<style lang="scss">
@import "./assets/scss/brand-fonts";
h1,h2 {
  font-family: "BookmanOldStyle", serif !important;
}
.coinmarketcap-currency-widget {
  > div {
    background-color: #FFF;
  }
}
</style>
